import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

// ANT DESIGN
import {
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Col,
  Divider,
  Spin,
  DatePicker,
  InputNumber,
  Table,
  Tooltip,
  Descriptions,
  Button,
  Modal,
} from "antd";
import {
  PlusOutlined,
  MinusOutlined,
  PlusCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

// PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import CustomButton from "../../../../../../components/custom/CustomButton";
import styles from "../../../../../../assets/styles/styles";
import { accountStatus } from "../../../../../../components/facilities/GroupFacility";

const Deposit = (props) => {
  const { Text, Title } = Typography;
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [paymentTypeData, setPaymentTypeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [customerMemberList, setCustomerMemberList] = useState([]);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [accountTableSource, setAccountTableSource] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAccountSelected, setIsAccountSelected] = useState(false);
  const [officeId, setOfficeId] = useState("");
  const [accountDetails, setAccountDetails] = useState([]);
  const [applicationData, setApplicationData] = useState([]);

  useEffect(() => {
    getTemplate();
    getDetailById();
  }, []);

  function onCancel() {
    navigate("/detail-group-gsim", { state: state });
  }

  const [ghost, setGhost] = useState(null);
  const Items = [
    {
      key: "1",
      label: "Show Payment Details",
      children: (
        <>
          <Row style={{ justifyContent: "spacebetween", marginTop: "15px" }}>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="accountNumber"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {labelConfig.accountNumber}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.accountNumber,
                    labelConfig.pleaseEnter
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="checkNumber"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {labelConfig.chequeNumber}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.chequeNumber,
                    labelConfig.pleaseEnter
                  )}
                  // style={{ width: "30vh" }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="routingCode"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {labelConfig.routingCode}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.routingCode,
                    labelConfig.pleaseEnter
                  )}
                  // style={{ width: "30vh" }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="receiptNumber"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {labelConfig.receiptNumber}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.receiptNumber,
                    labelConfig.pleaseEnter
                  )}
                  // style={{ width: "30vh" }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="bankNumber"
                label={
                  <Text style={{ fontSize: "16px" }}>{labelConfig.bank}</Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.bank,
                    labelConfig.pleaseEnter
                  )}
                  // style={{ width: "30vh" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
    },
  ];

  function getTemplate() {
    const url = `${apiConfig.SavingsAccounts}/${state.parentGSIMApplicationId}/transactions/template`;
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempPaymentType = [];

        objDetail?.paymentTypeOptions?.forEach((element) => {
          tempPaymentType.push({
            value: element.id,
            label: element.name,
          });
        });

        setPaymentTypeData(tempPaymentType);
        setIsLoading(false);
      }
    });
  }

  const getDetailById = () => {
    const params = {
      parentGSIMId: state.gsimId,
    };
    const url = `${apiConfig.Groups}/${state.id}/gsimaccounts`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res[0];

        let tempGSIMApplicationArray = [];
        let tempGSIMSavingsArray = [];

        objDetail?.childGSIMAccounts?.forEach((element) => {
          tempGSIMSavingsArray.push({
            key: element?.id,
            id: element?.id,
            productId: element?.productId,
            accountNo: element.accountNo ? element?.accountNo : "-",
            productName: element.productName ? element?.productName : "-",
            displayName: element.displayName ? element?.displayName : "-",
            balance: element.accountBalance ? element?.accountBalance : "-",
          });
        });
        objDetail?.childGSIMAccounts?.forEach((element) => {
          tempGSIMApplicationArray.push({
            value: element?.id,
            label: element.displayName ? element?.displayName : "-",
          });
        });

        setAccountDetails(tempGSIMSavingsArray);
        setApplicationData(tempGSIMApplicationArray);

        /**
         * STOP LOADER
         */
        setIsLoading(false);
      }
    });
  };

  const onSubmit = (formValues) => {
    const url = `${apiConfig.SavingsAccounts}/${state.parentGSIMApplicationId}/transactions`;
    const params = {
      command: "gsimDeposit",
    };
    formValues.transactionDate = BOM.DateTime(
      formValues.transactionDate,
      "only-date"
    );

    let tempAccountArray = [];
    accountTableSource.forEach((element, index) => {
      tempAccountArray.push({
        locale: "en",
        dateFormat: "dd MMMM yyyy",
        transactionAmount: element.transactionAmount,
        childAccountId: element.id,
        paymentTypeId: element.paymentTypeId,
        ...formValues,
      });
    });
    formValues.savingsArray = tempAccountArray;
    formValues.childAccounts = [];

    const body = {
      ...formValues,
      method: "POST",
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "GSIM Account was updated");
        navigate("/detail-group-gsim", {
          state: { ...state, statusValue: accountStatus.active },
        });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const handleAccountDelete = (key) => {
    let action = "Delete  ";
    let label = BOM.SubstringFormat(key.displayName, 20);

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = accountTableSource.filter((item) => item.id !== key.id);
        setAccountTableSource(newData);
      },

      function () {
        // No button
      }
    );
  };

  const columns = [
    {
      title: labelConfig.id,
      dataIndex: "id",
    },
    {
      title: labelConfig.name,
      dataIndex: "displayName",
    },
    {
      title: labelConfig.accountNumber,
      dataIndex: "accountNo",
    },
    {
      title: labelConfig.balance,
      dataIndex: "balance",
    },
    {
      title: labelConfig.transactionAmount,
      dataIndex: "transactionAmount",
    },
    {
      title: labelConfig.paymentTypes,
      dataIndex: "paymentType",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        accountTableSource.length >= 1 ? (
          <Tooltip title={`Remove Customer`}>
            <Button
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => handleAccountDelete(record)}
              shape="round"
              size="small"
              className="of-primaryBtnColor"
            />
          </Tooltip>
        ) : null,
    },
  ];

  return (
    <MainLayout isEnableRightSidebar={true}>
      <TopContent
        pageTitle={labelConfig.depositMoney}
        pageItems={staticConfig.depositBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Divider orientation="left" orientationMargin="0">
                <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                  {`Account No: ${state.accountNo}`}
                </Title>
              </Divider>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.transactionDate}
                  name={"transactionDate"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.date),
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%", height: 35 }}
                    disabledDate={BOM.DisabledAfterCurrentDate}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.savingsAccountInfo}
              </Title>
            </Divider>
            <SavingsAccountOVerview
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              setAccountTableSource={setAccountTableSource}
              accountTableSource={accountTableSource}
              customerDetails={customerDetails}
              customerMemberList={customerMemberList}
              officeId={officeId}
              isAccountSelected={isAccountSelected}
              setIsAccountSelected={setIsAccountSelected}
              paymentTypeData={paymentTypeData}
              ghost={ghost}
              setGhost={setGhost}
              Items={Items}
              accountDetails={accountDetails}
              applicationData={applicationData}
            />

            {accountTableSource?.length > 0 && (
              <>
                <Divider orientation="left" orientationMargin="0">
                  <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                    {accountTableSource.length > 1
                      ? labelConfig.selectedAccounts
                      : labelConfig.selectedAccount}
                  </Title>
                </Divider>
                <Table
                  columns={columns}
                  dataSource={accountTableSource}
                  bordered
                  pagination={{
                    position: "bottomCentre",
                    pageSize: "10",
                  }}
                />
              </>
            )}

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default Deposit;

const SavingsAccountOVerview = (props) => {
  const {
    setAccountTableSource,
    accountTableSource,
    isModalOpen,
    setIsModalOpen,
    customerDetails,
    isAccountSelected,
    setIsAccountSelected,
    paymentTypeData,
    ghost,
    setGhost,
    Items,
    accountDetails,
    applicationData,
  } = props;

  const { Title } = Typography;
  const [useForm] = Form.useForm();
  const [currentAccountDetails, setCurrentAccountDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCustomerSave = (formValues) => {
    // console.log(formValues);

    const newAccount = accountDetails?.find(
      (item) => item.id === formValues.accountId
    );

    const formData = {
      ...newAccount,
      paymentTypeId: formValues?.paymentTypeId,
      paymentType: paymentTypeData.find(
        (item) => item.value === formValues?.paymentTypeId
      ).label,
      transactionAmount: formValues?.transactionAmount,
    };

    // console.log(newAccount);

    let foundAccount = accountTableSource.find(
      (item) => item.id === newAccount?.id
    );
    if (foundAccount) {
      // console.log(newAccount);

      BOM.AlertMsg(cnt.WARNING, "No duplicate Account allowed!");
      return;
    }
    setAccountTableSource([...accountTableSource, formData]);

    useForm.resetFields();
  };

  const onChangeAccount = (accountParam) => {
    const currentAccountDetails = accountDetails?.find(
      (item) => item.id === accountParam
    );
    setCurrentAccountDetails(currentAccountDetails);
    setIsAccountSelected(true);
  };

  const items = [
    {
      key: "1",
      label: labelConfig.id,
      children: accountDetails ? currentAccountDetails.id : "-",
      span: 3,
    },
    {
      key: "2",
      label: labelConfig.name,
      children: accountDetails ? currentAccountDetails.displayName : "-",
      span: 3,
    },
    {
      key: "3",
      label: labelConfig.accountNumber,
      children: accountDetails ? currentAccountDetails.accountNo : "-",
      span: 3,
    },
    {
      key: "4",
      label: labelConfig.balance,
      children: accountDetails ? currentAccountDetails.balance : "-",
      span: 3,
    },
  ];

  return (
    <Row>
      <Button
        type="primary"
        shape="round"
        size="medium"
        className="of-primaryBtnColor"
        onClick={showModal}
        icon={<PlusCircleOutlined />}
      >
        {labelConfig.add}
      </Button>

      <Modal
        title="Savings Account Overview"
        open={isModalOpen}
        okText="Add"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmitLimit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            form={useForm}
            layout="vertical"
            onFinish={handleCustomerSave}
            name="address-info"
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left" orientationMargin="0">
              <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.selectChildGsimAccount}
              </Title>
            </Divider>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.accountList}
                name={"accountId"}
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.account),
                  },
                ]}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.account,
                    "select"
                  )}
                  options={applicationData}
                  showSearch
                  onChange={onChangeAccount}
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>

          {isAccountSelected && (
            <>
              <Descriptions
                bordered
                column={{
                  xs: 1,
                  sm: 2,
                  md: 2,
                  lg: 2,
                  xl: 2,
                  xxl: 2,
                }}
                style={{ marginTop: 10, marginBottom: 20 }}
                items={items}
              />
              <Row>
                <Col span={12} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.transactionAmount}
                    name={"transactionAmount"}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.transactionAmount),
                      },
                    ]}
                  >
                    <InputNumber
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                      style={styles.ofInputFieldNumber}
                    />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={labelConfig.paymentTypes}
                    name={"paymentTypeId"}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(labelConfig.paymentTypes),
                      },
                    ]}
                  >
                    <Select
                      filterOption={(input, option) =>
                        (option?.label?.toLowerCase() ?? "").includes(
                          input?.toLowerCase()
                        )
                      }
                      placeholder={BOM.handlePlaceholderMsg(
                        labelConfig.paymentTypes,
                        "select"
                      )}
                      options={paymentTypeData}
                      showSearch
                    />
                  </Form.Item>
                </Col>

                <Col span={24} style={{ padding: "0px 8px" }}>
                  <Collapse
                    ghost={ghost}
                    items={Items}
                    bordered={false}
                    expandIconPosition={"end"}
                    style={{ padding: "0px", marginBottom: 15, marginTop: 15 }}
                    expandIcon={({ isActive }) => {
                      {
                        isActive ? setGhost(false) : setGhost(true);
                      }
                      return (
                        <>
                          {isActive ? (
                            <MinusOutlined
                              style={{
                                backgroundColor: "#92428B",
                                color: "white",
                                padding: 8,
                                borderRadius: 10,
                              }}
                            />
                          ) : (
                            <PlusOutlined
                              style={{
                                backgroundColor: "#92428B",
                                color: "white",
                                padding: 8,
                                borderRadius: 10,
                              }}
                            />
                          )}
                        </>
                      );
                    }}
                  />
                </Col>
              </Row>
            </>
          )}
        </Spin>
      </Modal>
    </Row>
  );
};
